import { root, setupServiceInfo } from '@estee/elc-universal-utils';
import { ServiceManifest } from './manifest';

setupServiceInfo(__serviceInfo__);

root.ServiceRegistry['elc-service-communications'] = ServiceManifest;
